exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".KC6Vap19Ya6lKICPKSVyK{max-width:700px;margin:80px auto}\n", ""]);

// Exports
exports.locals = {
	"TrialLandingPage": "KC6Vap19Ya6lKICPKSVyK"
};